import { Component, AfterViewInit, OnInit, Inject } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, NavigationStart } from "@angular/router";
import { IHRBMicroUiConfig } from './shared/interfaces/hrblock-micro-ui-config-interface';
import { IPreorderResponse } from './shared/interfaces/data-micro-ui-interface';
import { microApps } from './shared/services/config';
import { microUI, upgradePGKs, orderSummaryEvents, productDetailsEvents, nuDataEvents, billingAndPaymentEvents, eventActions, couponCodeEvents, orderConfirmationEvents } from './shared/constants';
import { DataService } from './shared/services/data.service';
import { AnalyticsService } from './shared/services/analytics.service';
import { IpServiceService } from './shared/services/ip-service.service';
import { NuDataService } from './shared/services/nuData.service'; // Keep this Service
import { environment } from '../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  public OrderSummary: IHRBMicroUiConfig = microApps[microUI.orderSummary];
  public ApplyCouponCode: IHRBMicroUiConfig = microApps[microUI.couponCode];
  activeRoute = { cart: false, billing: false, confirmation: false, autorenewal: false, taxidentityshield: false };
  displayBreadcrumb = true;
  cartOrderCompleted = false;
  billingOrderCompleted = false;
  displayStaticInfoOnly = false;
  public toggleText: boolean = false;
  public isOrderSummary: boolean = false;
  public showCoupon: boolean;
  public noState: boolean;
  public productName: string;
  public preOrderDate: IPreorderResponse;
  public productDetailsLoaded: boolean;
  public orderSummaryLoaded: boolean = false;

  constructor(private router: Router, private dataService: DataService,
    private analyticsService: AnalyticsService, @Inject('BASE_URL') private originUrl: string,
    @Inject('TAX_YEAR') private taxYear: string, @Inject('SERVICE_ID') private serviceId: string,
    @Inject('OTP_PARTNER_ID') private otpPartnerId: string,
    @Inject('PRICE_GROUP_KEY') private priceGroupKey: string,
    @Inject('PROMO_CODE') private promoCode: string,
    @Inject('SKU') private sku: string, private ip: IpServiceService,
    @Inject('STATE') private state: string) {
    console.log("BASE_URL v2", originUrl);
    console.log("SERVICE_ID", serviceId);
    console.log("OTP_PARTNER", otpPartnerId);
    console.log("Tax Year", taxYear);
    console.log("State", state.length, state);
    console.log("Promo Code", promoCode.length, promoCode);
    console.log("Default PRICE_GROUP_KEY", priceGroupKey);
    console.log("SKU", sku);
    this.dataService.setBaseUrl(originUrl);
    this.dataService.setTaxYear(taxYear);
    this.dataService.setPriceGroupKey(priceGroupKey);
    if (state.length > 0) {
      this.noState = false;
      this.dataService.setSku(`win_${state.toLowerCase()}`)
    } else {
      this.noState = true;
      this.dataService.setSku(sku);
    }
    this.setUpgradeDevices(promoCode, sku, priceGroupKey);
    this.dataService.setState(state);
    this.dataService.setPromoCode(promoCode);
    this.productDetailsLoaded = false;
    //Generate unique Service ID to use on transactions
    this.dataService.setServiceId(serviceId);
    console.log("environment")
    console.log(environment)
    if(!window['jasmine']){
      this.analyticsInit();
    }
    //analyticsService.pageTrack();
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(() => {
      if (window.location.pathname === "/billing" && !this.displayBreadcrumb) {
        window.location.href = window.location.origin + '/cart' + window.location.search;
      } else if (window.location.pathname === "/shoppingcart/billing" && !this.displayBreadcrumb) {
        window.location.href = window.location.origin + '/shoppingcart/cart' + window.location.search;
      }
    });
  }

  onRouteChange(_, name) {
    Object.assign(this.activeRoute, Object.entries(this.activeRoute)
      .reduce((accum, [route, display]) => {
        display = route === name;
        accum[route] = display;
        return accum;
      }, {}))
  }

  ngOnChange() {
    this.activeRoute.cart = true;
    if (this.activeRoute["confirmation"]) {
      this.displayBreadcrumb = false;
    }
  }

  redirectToCart() {
    this.router.navigate(['/cart'], { queryParamsHandling: "merge" }).then(() => {
      this.activeRoute.cart = true;
      this.activeRoute.billing = false;
    })
  }

  goToPayment() {
    this.router.navigate(['/billing'], { queryParamsHandling: "merge" }).then(() => {
      this.activeRoute.cart = false;
      this.activeRoute.billing = true;
    })
  }

  /**
   * When meeting certain constraints we will only use WIN/MAC device
   * we have to do this only using selected PGKs
   * @param promoCode
   * @param sku
   */
  setUpgradeDevices(promoCode: string, sku: string, pgk: string) {
    if (promoCode.length > 0 && sku.length > 0) {
      const foundPgk = upgradePGKs.find(currentPgk => currentPgk === pgk);
      if (foundPgk) {
        this.dataService.setDeviceSelection(sku.substring(0, 3).toLowerCase());
      } else {
        this.dataService.setDeviceSelection('');
      }
    } else {
      this.dataService.setDeviceSelection('');
    }
  }

  goToConfirmation() {
    this.router.navigate(['/confirmation'], { queryParamsHandling: "merge" }).then(() => {
      this.isOrderSummary = true;
      this.activeRoute.cart = false;
      this.activeRoute.billing = false;
      this.activeRoute.confirmation = true;
      this.displayBreadcrumb = false;
      // get data to populate your receipt
      const yourReceiptData = this.dataService.getFinalOrderSummaryData();
      // send data to populate your receipt
      const comp = document.querySelector(microUI.orderSummary);
      if (comp)
        comp[eventActions.setOrderConfirmation] = yourReceiptData;
    })
  }

  //Analytics Init
  /* istanbul ignore next*/
  analyticsInit() {
    let script = document.createElement('script');
    script.src = environment.adobeUrl;
    script.onload = function () {
      //Cookie
      function getDTMCookie(cname) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      //Set HRBData events variable
      window.HRBData = { digital_data: {} }
      //This setup is to track the application location
      window.HRBData.digital_data.page_section = 'hrblock';
      window.HRBData.digital_data.page_sub_section = 'software';
      window.HRBData.digital_data.return_type = '';
      window.HRBData.digital_data.page_title = 'cart';

      //Validate _satellite variable we get from adobe analytics
      if (typeof _satellite == 'undefined') {
        var _satellite: any = {};
        _satellite.track = function (event) {
          console.log("DTM tracking for " + event + " blocked");
        };

        _satellite.pageBottom = function () {
          console.log("DTM method pagebottom blocked");
        };
      } else {
        var _satellite = _satellite;
      }

      let bottomScript = document.createElement('script');
      let code = 'window._satellite.pageBottom();';
      try {
        bottomScript.appendChild(document.createTextNode(code));
        document.body.appendChild(bottomScript);
      } catch (e) {
        bottomScript.text = code;
        document.body.appendChild(bottomScript);
      }

      //GDPR
      let satTrackVal = getDTMCookie('sat_track');
      console.log("GDPR", satTrackVal)
      if (satTrackVal === 'true') {
        window.HRBData.digital_data.eu_compliance = 'true';
        console.log('HRBData.digital_data.eu_compliance: ' + window.HRBData.digital_data.eu_compliance);
      } else if (satTrackVal === 'false') { // will only occur for expat pages
        window.HRBData.digital_data.eu_compliance = 'false';
        console.log('HRBData.digital_data.eu_compliance: ' + window.HRBData.digital_data.eu_compliance);
      } else {
        /*  If undefined, this is first page view.
            Turn on tracking. Non-EU tracking must be on. EU users will have opportunity to turn it off. */
        document.cookie = "sat_track=true; expires=5*365; path=/";
        window.HRBData.digital_data.eu_compliance = 'true';
        console.log('HRBData.digital_data.eu_compliance: ' + window.HRBData.digital_data.eu_compliance);
      }
    };
    document.head.appendChild(script);
  }

  /* istanbul ignore next*/
  getIP() {
    this.ip.getIPAddress()
      .subscribe((res) => {
        this.dataService.setClientIp(res.ip);
        console.log("IP", res);

        const couponComp = document.querySelector(microUI.couponCode);
        const productComp = document.querySelector(microUI.productDetails);

        if (couponComp)
          couponComp.setAttribute(eventActions.client_ip, res.ip);

        if (productComp)
          productComp.setAttribute(eventActions.client_ip, res.ip);
      }, this.handleError);
  }

  //NUData initial state
  /* istanbul ignore next*/
  async nuDataInit() {
    const sessionId = String(this.serviceId);
    const ndClientId = environment.ndClientId;
    const baseUrl = environment.baseUrl + ndClientId + "/sync/js/";
    console.log('baseUrl', baseUrl);
    console.log('ndclient', ndClientId);

    (function (w, d, s, u, q, js, fjs, nds) {
      nds = w.ndsapi || (w.ndsapi = {}); nds.config = {
        q: [], ready: function (cb) {
          this.q.push(cb)
        }
      }; js = d.createElement(s); fjs = d.getElementsByTagName(s)[0];
      js.src = u; fjs.parentNode.insertBefore(js, fjs); js.onload = function () {
        nds.load(u);
      }
    }(window, document, "script", baseUrl));

    let nds = window.ndsapi;

    console.log('Service Id ', sessionId);
    console.log("nuDataInit", nds);
    nds.config.ready(function () {
      nds.setSessionId(sessionId);
      nds.setPlacement('Purchase');
      nds.setPlacementPage('1');
      nds.registerListeners(['mo', 'kb', 'fc', 'to']);
      nds.rebindListeners();
    });

    console.log('Nudata Sessionid', nds.config);
  }

  async initializeNuData(): Promise<void> {
    try {
      await this.nuDataInit(); 
    } catch (error) {
      console.error('Error : nuDataInit loaded ', error);
    }
  }


  ngOnInit() {
    //Gets Clients IP
    this.getIP();
    this.initializeNuData();
    this.eventListernersInit();

    if (["/cart", "/shopping/cart"].some(a => a === window.location.pathname)) {
      this.activeRoute.cart = true;
    }

    if (["/autorenewal", "/taxidentityshield", "/terms", "/terms/autorenewal", "/terms/taxidentityshield",
      "/shoppingcart/autorenewal", "/shoppingcart/taxidentityshield", "/shoppingcart/terms", "/shoppingcart/terms/autorenewal",
      "/shoppingcart/terms/taxidentityshield"].some(a => a === window.location.pathname)) {
      this.displayStaticInfoOnly = true;
    }

    if ((window.location.pathname === "/billing" || window.location.pathname === "/shoppingcart/billing") && (!this.cartOrderCompleted || !this.displayBreadcrumb)) {
      this.redirectToCart()
    } else if ((window.location.pathname === "/confirmation" || window.location.pathname === "/shoppingcart/confirmation") && (!this.cartOrderCompleted || !this.billingOrderCompleted)) {
      this.redirectToCart();
    }

  }

  eventListernersInit() {

    //handle event from product details and send NO Free Tis Option to order summary
    addEventListener(productDetailsEvents.noFreeTisOption, (evt: CustomEvent) => {
      
      const comp = document.querySelector(microUI.orderSummary);
      if (comp)
        comp[eventActions.noFreeTisOption] = evt.detail;
    });

    //handle event from product details and add product to order summary
    addEventListener(productDetailsEvents.addProduct, (evt: CustomEvent) => {
      this.dataService.addToRecommendedProductsInfo(evt.detail);
      const comp = document.querySelector(microUI.orderSummary);
      if (comp)
        comp[eventActions.addProduct] = evt.detail;
    });

    //handle event from order summary to set show Payment Form
    addEventListener(orderSummaryEvents.showPaymentForm, (evt: CustomEvent) => {
      console.log("LLL", evt.detail);
      this.dataService.setShowPaymentForm(evt.detail);
    });

    //handle event from product details when priorYear is not set correctly
    addEventListener(productDetailsEvents.validatePriorYear, (evt: CustomEvent) => {
      const compProductDetails = document.querySelector(microUI.productDetails);
      if (compProductDetails && this.preOrderDate !== undefined) {
        compProductDetails[eventActions.preOrderDate] = this.preOrderDate.preOrderEnabled;
        compProductDetails[eventActions.prior_tax_year] = `${this.preOrderDate.priorTaxYear}`;
        compProductDetails[eventActions.taxYear] = this.preOrderDate.taxYear;
      }
    });

    //handle event from order summary to set Pre Order Date
    addEventListener(orderSummaryEvents.setPreOrder, (evt: CustomEvent) => {
      this.preOrderDate = evt.detail;
      this.dataService.setPreOrder(evt.detail);
      if (this.noState)
        this.showCoupon = !this.dataService.getPreOrder().priorTaxYear;
      const compOrderSummary = document.querySelector(microUI.orderSummary);
      console.log("PRIOR DATA", evt.detail);
      if (compOrderSummary)
        compOrderSummary[eventActions.preOrderDate] = evt.detail.preOrderEnabled;
    });
 
    // Handle event from product details and add product to order summary
    addEventListener(productDetailsEvents.setAutoRenewal, (evt: CustomEvent) => {
      this.dataService.setAutoRenewal(evt.detail);
      // Update the order summary component
      const orderSummaryComp = document.querySelector(microUI.orderSummary);
      if (orderSummaryComp) {
        orderSummaryComp[eventActions.setAutoRenewal] = evt.detail;
      }

      // Update the product details component
      const productDetailsComp = document.querySelector(microUI.productDetails);
      if (productDetailsComp) {
        productDetailsComp[eventActions.setAutoRenewal] = evt.detail;
      }
    });

    //handle event from product details to set default price group key
    addEventListener(productDetailsEvents.setPriceGroupKey, (evt: CustomEvent) => {
      this.dataService.setPriceGroupKey(evt.detail);
      const compOrderSummary = document.querySelector(microUI.orderSummary);
      const compApplyCoupon = document.querySelector(microUI.couponCode);
      if (compOrderSummary)
        compOrderSummary[eventActions.price_group_key] = evt.detail;
      if (compApplyCoupon)
        compApplyCoupon[eventActions.price_group_key] = evt.detail;
    });

    //handle event from product details and set auto renewal info in root
    addEventListener(productDetailsEvents.setAutoRenewalInformation, (evt: CustomEvent) => {
      this.dataService.setAutoRenewalInformation(evt.detail);
    });

    //handle event from product details and remove product from order summary
    addEventListener(productDetailsEvents.removeProduct, (evt: CustomEvent) => {
      this.dataService.removeToRecommendedProductsInfo(evt.detail);
      const comp = document.querySelector(microUI.orderSummary);
      if (comp)
        comp[eventActions.removeProduct] = evt.detail;
    });

    //handle event from product details and remove product from order summary
    addEventListener(productDetailsEvents.selectDevice, (evt: CustomEvent) => {
      this.dataService.setDeviceTypeInfo(evt.detail);
      const comp = document.querySelector(microUI.orderSummary);
      if (comp)
        comp[eventActions.selectDevice] = evt.detail;
    });

    //handle event from product details and updates navigation on Root component
    addEventListener(productDetailsEvents.continueToBillingInfo, (evt: CustomEvent) => {
      if (this.dataService.getDeviceTypeInfo()) {
        this.cartOrderCompleted = evt.detail;
        this.goToPayment()
      } else {
        const comp = document.querySelector(microUI.productDetails);
        if (comp) {
          comp[eventActions.validateDevice] = evt.detail;
        }
      }
    });

    //handle event from billing and payment and updates navigation on Root component
    addEventListener(billingAndPaymentEvents.continueToOrderConfirmation, (evt: CustomEvent) => {
      this.billingOrderCompleted = evt.detail;
      this.goToConfirmation();
    });

    //handle event from product details and updates product information in Root and order summary
    addEventListener(productDetailsEvents.setProductInformation, (evt: CustomEvent) => {
      this.dataService.setPrductDetailsInfo(evt.detail);
      // product name to use on banner
      this.productName = evt.detail.description;
      const comp = document.querySelector(microUI.orderSummary);
      if (comp)
        comp[eventActions.orderSummaryProduct] = evt.detail;
    });

    //handle event from device products details and updates device products information in Root
    addEventListener(productDetailsEvents.setDeviceProductsInformation, (evt: CustomEvent) => {
      if (!this.dataService.getDeviceProductsInfo()) {
        this.dataService.setDeviceProductsInfo(evt.detail);
      }
    });

    //handle event from product details and updates recommended products information in Root
    addEventListener(productDetailsEvents.setRecommendedProductsInformation, (evt: CustomEvent) => {
      if (!this.dataService.getRecommendedProductsInfo()) {
        this.dataService.setRecommendedProductsInfo(evt.detail);
      }
    });

    //handle event from order summary and remove product from product details
    addEventListener(orderSummaryEvents.removeProduct, (evt: CustomEvent) => {
      this.dataService.removeToRecommendedProductsInfo(evt.detail);
      const comp = document.querySelector(microUI.productDetails);
      if (comp) {
        comp[eventActions.removeProduct] = evt.detail;
      }
      if (evt.detail.description == 'Backup CD') {
        const billingComp = document.querySelector(microUI.billingAndPayment);
        if (billingComp)
          billingComp[eventActions.backUpCdInfo] = false;
      }
      if (evt.detail.description == 'Tax Identity Shield') {
        const billingComp = document.querySelector(microUI.billingAndPayment);
        if (billingComp) {
          billingComp[eventActions.terms] = this.dataService.getTermsAndConditions();
        }

      }
    });

    //handle event from order summary and updates OrderSummaryResponse from priceRequest
    addEventListener(orderSummaryEvents.setPricingEngineResponse, (evt: CustomEvent) => {
      this.dataService.setOrderSummaryResponse(evt.detail);
    });

    //handle event from billing nad payment to update billing information for signature
    addEventListener(billingAndPaymentEvents.setPricingEngineResponse, () => {
      const billingAndPaymentComp = document.querySelector(microUI.billingAndPayment);
      if (billingAndPaymentComp) {
        billingAndPaymentComp[eventActions.service] = this.dataService.getServiceId();
        billingAndPaymentComp[eventActions.orderSummaryResponse] = this.dataService.getOrderSummaryResponse();
      }
    });

    //handle event from billing and payment info and update billing information in Root
    addEventListener(billingAndPaymentEvents.setBillingInformation, (evt: CustomEvent) => {
      this.dataService.setBillingInfo(evt.detail);
      const orderSummaryComp = document.querySelector(microUI.orderSummary);
      if (orderSummaryComp) {
        orderSummaryComp[eventActions.orderbillingInfo] = evt.detail;
      }
    });

    //handle event from billing and payment info and update shipping information in Root
    addEventListener(billingAndPaymentEvents.setShippingInformation, (evt: CustomEvent) => {
      this.dataService.setShippingInfo(evt.detail);
    });

    //handle event from billing and payment info and update payment information in Root
    addEventListener(billingAndPaymentEvents.setPaymentInformation, (evt: CustomEvent) => {
      this.dataService.setPaymentInfo(evt.detail);
    });

    //setTransactionUuid
    addEventListener(billingAndPaymentEvents.setTransactionUuid, (evt: CustomEvent) => {
      this.dataService.setTransactionUuid(evt.detail);
      const orderSummaryComp = document.querySelector(microUI.orderSummary);
      if (orderSummaryComp) {
        orderSummaryComp[eventActions.transactionUuid] = this.dataService.getTransactionUuid();
      }
    });

    //handle event from billing and payment info and update payment masked information in Root
    addEventListener(billingAndPaymentEvents.setPaymentMaskedInformation, (evt: CustomEvent) => {
      this.dataService.setPaymentMaskedInfo(evt.detail);
    });

    //handle event from order summary and update autorenewal on Root component
    addEventListener(productDetailsEvents.toggleAutoRenewal, (evt: CustomEvent) => {
      this.dataService.toggleAutoRenewalTermsAndConditions(evt.detail);
      const billingComp = document.querySelector(microUI.billingAndPayment);
      if (billingComp) {
        billingComp[eventActions.terms] = this.dataService.getTermsAndConditions();
      }
    });

    //handle event from coupon code on root and return data to coupon code
    addEventListener(couponCodeEvents.getProductsData, (evt: CustomEvent) => {
      const couponCodeComp = document.querySelector(microUI.couponCode);
      if (couponCodeComp) {
        couponCodeComp[eventActions.productsDiscount] = this.dataService.getDiscountData();
      }
    });

    //handle event from order confirmation on root and return data to order confirmation
    addEventListener(orderConfirmationEvents.getActivationResquestData, (evt: CustomEvent) => {
      const orderConfirmationComp = document.querySelector(microUI.orderConfirmation);
      if (orderConfirmationComp) {
        orderConfirmationComp[eventActions.activationCode] = this.dataService.getActivationRequestData();
      }
    });

    //handle event from coupon code on root and apply discount on order summary
    addEventListener(couponCodeEvents.setCouponCode, (evt: CustomEvent) => {
      const orderSummaryComp = document.querySelector(microUI.orderSummary);
      if (orderSummaryComp) {
        orderSummaryComp[eventActions.couponCodeDiscount] = evt.detail;
      }
    });

    //handle event from coupon code on root and release coupon on order summary
    addEventListener(couponCodeEvents.releaseCouponCode, (evt: CustomEvent) => {
      const orderSummaryComp = document.querySelector(microUI.orderSummary);
      if (orderSummaryComp) {
        orderSummaryComp[eventActions.couponReleaseCode] = evt.detail;
      }
    });

    //handle event from order summary on root and update coupon code
    addEventListener(orderSummaryEvents.updateCouponCode, (evt: CustomEvent) => {
      const couponCodeComp = document.querySelector(microUI.couponCode);
      if (couponCodeComp) {
        couponCodeComp[eventActions.updateCouponCode] = this.dataService.getDiscountData();
      }
    });

    //handle event from order summary on root and release coupon on coupon code
    addEventListener(orderSummaryEvents.releaseCouponCode, (evt: CustomEvent) => {
      const couponCodeComp = document.querySelector(microUI.couponCode);
      if (couponCodeComp) {
        couponCodeComp[eventActions.couponReleaseCode] = evt.detail;
      }
    });

    //handle event from order summary and toggle text
    addEventListener(orderSummaryEvents.toggleText, (evt: CustomEvent) => {
      this.toggleText = evt.detail;
    });

    //handle event when coupon code loads for the first time and sets sessionId
    addEventListener(nuDataEvents.couponCodeMicroLoaded, () => {
      //this.nuDataInit();
    })

    //handle event to bind new fields on billing and payment
    addEventListener(nuDataEvents.billingAndPaymentFieldLoaded, () => {
    })

  }

  ngAfterViewInit() {
    window.addEventListener("load", function (event) {
     if(event.isTrusted)
      {
       const el = document.getElementById('fixedTop');
       let leftContainer: HTMLCollection;
       let orderSummaryContainer: HTMLCollection = document.getElementsByClassName("order-container");
       if (el) {
         const elTop = el.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
         if (orderSummaryContainer) {
           const orderSummaryHeight: Element = orderSummaryContainer[0];
           window.addEventListener('scroll', function () {
            leftContainer = document.getElementsByClassName("left-container");
            const leftContainerHeight: Element = leftContainer[0];
            if (document.documentElement.scrollTop > elTop || document.body.scrollTop > elTop) {
              if (orderSummaryHeight.getBoundingClientRect().height < leftContainerHeight.getBoundingClientRect().height) {
                el.classList.add("_fixedTop");
              }
            }
            else {
              el.classList.remove("_fixedTop")
            }
           });
          }
        }
      }
    });
  }
  // Error handling
  private handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    console.log("IP ERROR", errorMessage);
    this.dataService.setClientIp('0.0.0.0');

    return throwError(errorMessage);
  }

  /* ngOnDestroy(): void {
    this._subscription_back_up_cd$.unsubscribe();
  } */

}
